import constants from "../constants";

const {
  FETCH_SUBTYPES_DONE,
  CLEAR_LIST,
} = constants;

function filters(state = [], action) {
  switch (action.type) {
    case CLEAR_LIST: {
      return [];
    }
    case FETCH_SUBTYPES_DONE: {
      return [...action.data];
    }
    default: {
      return state;
    }
  }
}

export default filters;


// WEBPACK FOOTER //
// ./assets/list/reducers/subtypes.js